// Coins a host spends to start another game once the 3 free ones are used.
export const ROOM_LIMIT_COST = 30;

// Waiting lobbies one host can have open at once.
export const MAX_OPEN_LOBBIES = 3;
